import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-section-testimonials',
    templateUrl: './section-testimonials.component.html',
    styleUrls: ['./section-testimonials.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionTestimonialsComponent implements OnInit, OnDestroy {

  @ViewChild('videoBox') videoBox!: ElementRef<HTMLElement>;

  private player: any;
  private pendingIframe: HTMLIFrameElement | null = null;

  // Removes the player when the user exits fullscreen so the poster returns
  private onFullscreenChange = (): void => {
    if (!document.fullscreenElement) {
      this.videoBox?.nativeElement.querySelector('iframe.youtube-player')?.remove();
      this.player = null;
    }
  };

  private openFullscreen(iframe: HTMLIFrameElement): void {
    if (document.fullscreenElement) {
      return;
    }
    iframe.requestFullscreen?.().catch(() => {
      // Fullscreen unavailable (e.g. iOS Safari) - video keeps playing inline
    });
  }

  private isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  // Attaches the YouTube IFrame API to the embed: once the player is ready
  // (still inside the click's activation window) we go fullscreen and force play
  private setUpPlayer(iframe: HTMLIFrameElement): void {
    const YT = (window as any).YT;
    try {
      this.player = new YT.Player(iframe, {
        videoId: iframe.dataset['videoId'],
        playerVars: { autoplay: 1, rel: 0, playsinline: 1 },
        events: {
          onReady: () => {
            this.openFullscreen(iframe);
            this.player?.playVideo();
          },
          onStateChange: (state: any) => {
            // Retry fullscreen once playback actually starts, in case the
            // ready event fired after the activation window closed
            if (state?.data === 1) {
              this.openFullscreen(iframe);
            }
          }
        }
      });
    } catch {
      this.openFullscreen(iframe);
    }
  }

  // Opens the YouTube video in fullscreen with autoplay on first click
  playVideo(event: Event, videoId: string): void {
    event.preventDefault();
    const box = this.videoBox.nativeElement;
    let iframe = box.querySelector<HTMLIFrameElement>('iframe.youtube-player');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.className = 'youtube-player';
      iframe.dataset['videoId'] = videoId;
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;
      iframe.title = 'Yoga by Vishwas video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';
      box.appendChild(iframe);
    }

    // Safari requires the fullscreen request inside the click gesture itself;
    // everywhere else we keep the activation for the player's autoplay decision
    // and enter fullscreen as soon as the player is ready (onReady above).
    if (this.isSafari()) {
      this.openFullscreen(iframe);
    }

    if ((window as any).YT?.Player) {
      this.setUpPlayer(iframe);
    } else {
      this.pendingIframe = iframe;
      (window as any).onYouTubeIframeAPIReady = () => {
        if (this.pendingIframe) {
          this.setUpPlayer(this.pendingIframe);
          this.pendingIframe = null;
        }
      };
    }
  }

  data:any = {
    experience: {
      title: "Experience",
      items: [
        {
          count: "15",
          title: "Years of Experience"
        },
        // {
        //   count: "340",
        //   title: "Project Taken"
        // },
        // {
        //   count: "86",
        //   title: "Awards Won"
        // },
        // {
        //   count: "6081",
        //   title: "Instagram Followers"
        // }
      ]
    },
    testimonials: {
      title: "Testimonial",
      content: [
        {
          name: "Cheryl Ling",
          quote: "“It was a very pleasant photoshooting experience with Vishwas. We met to discuss the details of the shoot before the actual shooting day. He understands what his clients are asking for. Being a local himself, he is familiar with the best places to shoot around Mysore. He is an attentive and a passionate photographer who will definitely meets your expectation. Will definitely engage him as my photographer in the coming future! Loving all my pictures taken by him, which have received many compliments from my friends.”",
          link: "https://g.co/kgs/LzfwpE"
        },
        {
          name: "IngerYoga",
          quote: "“The photoshoot with Vishwas was great. It was efficient, with high quality photos. Photoshoot had a great price and photographer gives you all the photos he took. Vishwas is a really nice guy and you will surely enjoy photoshooting with him. I reccomend it.”",
          link: "https://g.co/kgs/QxixAs"
        }


      ]
    }
  }
  
  constructor() { }

  ngOnInit(): void {
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    // Preload the YouTube IFrame API so player setup is fast on first click
    if (!(window as any).YT && !document.getElementById('youtube-iframe-api')) {
      const script = document.createElement('script');
      script.id = 'youtube-iframe-api';
      script.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(script);
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
  }

}
